export default __webpack_public_path__ + "static/media/DSZ Price Shipping Fee Review 24072025.7f997997.zip";